import { Tabs, message } from 'antd';
import { Dayjs } from 'dayjs';
import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { getDefaultDates } from 'src/utils/date-util';
import { formatDate } from 'src/utils/date-util';

import useInboundTransactions from 'src/hooks/subscription/useInboundTransactions';
import useDateForTableOptions from 'src/hooks/useDateForTableOptions';
import { useTitle } from 'src/hooks/useTitle';

import InventoryInboundHistoryTable from 'src/atomic-components/organisms/Tables/InventoryInboundHistoryTable';
import TableOptions from 'src/components/Common/TableOptions/TableOptions';
import Loading from 'src/components/Loading/Loading';

const defaultValue = getDefaultDates(1, 0);
const dayjsesToStringDateWhere = (left: Dayjs, right: Dayjs): [string, string] => {
  const leftDate = formatDate(left.toDate(), 'yyyy-MM-dd');
  const rightDate = formatDate(right.toDate(), 'yyyy-MM-dd');
  return [leftDate, rightDate];
};

const InventoryInboundHistoryBoard: FC = () => {
  useTitle('입고 내역');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'all';
  const { dates, setDates, leftDate, rightDate } = useDateForTableOptions(dayjsesToStringDateWhere, defaultValue);
  const { inboundTransactions, loading, error } = useInboundTransactions(tab, leftDate, rightDate);

  const onTabChange = (key: string) => {
    navigate(`../inbound-history?tab=${key}`);
  };

  useEffect(() => {
    if (error) {
      message.error(error, 10);
    }
  }, [error]);

  return (
    <div className='height100 flexColumn'>
      <TableOptions setDates={setDates} defaultValue={dates} />
      <Tabs
        activeKey={tab}
        onChange={onTabChange}
        style={{ height: '100%', overflow: 'scroll' }}
        items={[
          {
            key: 'all',
            label: '전체 입고',
            children: <InventoryInboundHistoryTable rowData={inboundTransactions} />,
          },
          {
            key: 'supplier',
            label: '거래처 입고',
            children: <InventoryInboundHistoryTable rowData={inboundTransactions} hideReferenceCollection={true} />,
          },
          {
            key: 'issue',
            label: '재고 이슈',
            children: <InventoryInboundHistoryTable rowData={inboundTransactions} hideReferenceCollection={true} />,
          },
          {
            key: 'store',
            label: '매장 이슈',
            children: <InventoryInboundHistoryTable rowData={inboundTransactions} hideReferenceCollection={true} />,
          },
        ]}
      />
      {loading && <Loading title='입고 내역 로딩중...' />}
    </div>
  );
};

export default InventoryInboundHistoryBoard;
